import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from "../lib/utils.js";
import { themeToCssVariables } from "../tokens/tenant.js";
import { paguzTheme } from "../tokens/theme.js";
const ThemeContext = React.createContext(paguzTheme);
/** Tema activo (para leer colores en JS, p. ej. gráficos o `<meta name="theme-color">`). */
export function useTheme() {
    return React.useContext(ThemeContext);
}
/**
 * Tema por tenant con variables CSS. Todo lo que está dentro (componentes y utilidades
 * `bg-primary`, `text-highlight`…) usa los colores del tenant.
 */
function ThemeProvider({ theme = paguzTheme, global = false, className, style, children, ...props }) {
    const variables = React.useMemo(() => themeToCssVariables(theme), [theme]);
    React.useLayoutEffect(() => {
        if (!global)
            return;
        const root = document.documentElement;
        const entries = Object.entries(variables);
        const previous = entries.map(([name]) => [name, root.style.getPropertyValue(name)]);
        const previousTenant = root.dataset.tenant;
        for (const [name, value] of entries)
            root.style.setProperty(name, value);
        root.dataset.tenant = theme.name;
        return () => {
            for (const [name, value] of previous) {
                if (value)
                    root.style.setProperty(name, value);
                else
                    root.style.removeProperty(name);
            }
            if (previousTenant === undefined)
                delete root.dataset.tenant;
            else
                root.dataset.tenant = previousTenant;
        };
    }, [global, theme.name, variables]);
    return (_jsx(ThemeContext.Provider, { value: theme, children: _jsx("div", { "data-slot": "theme-provider", "data-tenant": theme.name, className: cn('bg-background font-sans text-foreground', className), style: global ? style : { ...variables, ...style }, ...props, children: children }) }));
}
export { ThemeProvider };
//# sourceMappingURL=theme-provider.js.map